module.exports = __webpack_public_path__ + "b7e21e64d7f960e24cf426702d233be7.png";